import React from "react";
import { PriceBreakdownTableView } from "./view";
import { styles } from "./styles";

export class PriceBreakdownTable extends React.Component {
  render() {
    return <PriceBreakdownTableView {...this.props} styles={styles} />;
  }
}
